export default function ReviewStep({ form, projectId, status, liveUrl }) {
    const basicItems = [
        ["Business Name", form.businessName],
        ["Industry", form.industry],
        ["Sub Industry", form.subIndustry],
        ["Tone", form.tone],
        ["Theme", formatTheme(form.themeKey)],
        ["Goal", form.goalOfWebsite],
        ["CTA", form.callToActionType],
        ["Brand Style", form.brandStyle],
        ["Price Positioning", form.pricePositioning],
        ["Project ID", projectId || "-"],
        ["Status", status || "Not saved yet"]
    ];

    const strategyItems = [
        ["Business Model", form.businessModel],
        ["Website Mode", form.primaryWebsiteMode],
        ["Primary Entity", form.primaryEntityType],
        ["Location Focus", form.locationFocus],
        ["Content Style Hint", form.contentStyleHint],
        ["Desired Layout", form.desiredLayoutStyle],
        ["Visual Tone", form.visualTone],
        ["Section Density", form.preferredSectionDensity]
    ];

    const audienceItems = [
        ["Primary Audience", form.primaryAudience],
        ["Secondary Audience", form.secondaryAudience],
        ["Location", form.location],
        ["Service Areas", form.serviceAreas]
    ];

    const contentItems = [
        ["Core Services", form.coreServices],
        ["Project Types", form.projectTypes],
        ["Unique Selling Points", form.uniqueSellingPoints],
        ["Trust Signals", form.trustSignals],
        ["Must Include Words", form.mustIncludeWords],
        ["Avoid Words", form.avoidWords],
        ["Competitor Style Notes", form.competitorStyleNotes]
    ];

    const pages = Array.isArray(form.pages) ? form.pages : [];

    return (
        <div className="wg-review-step">
            <div>
                <h2 className="wg-section-title">Review & Actions</h2>
                <p className="wg-section-subtitle">
                    Review the selected details before saving, previewing, and publishing.
                </p>
            </div>

            <ReviewGroup title="Project Overview" items={basicItems} />
            <ReviewGroup title="Generation Strategy" items={strategyItems} />
            <ReviewGroup title="Audience & Coverage" items={audienceItems} />

            <div className="wg-review-group">
                <h3 className="wg-review-group-title">Description</h3>
                <div className="wg-review-item wg-review-item-full">
                    <span>{form.description || "-"}</span>
                </div>
            </div>

            <div className="wg-review-group">
                <h3 className="wg-review-group-title">Recommended Pages</h3>
                <div className="wg-review-tags">
                    {pages.length > 0 ? (
                        pages.map((page) => (
                            <span key={page} className="wg-review-tag">
                                {page}
                            </span>
                        ))
                    ) : (
                        <span className="wg-review-empty">-</span>
                    )}
                </div>
            </div>

            <ReviewGroup title="Content Inputs" items={contentItems} />

            <div className="wg-review-group">
                <h3 className="wg-review-group-title">Live URL</h3>
                <div className="wg-review-item wg-review-item-full">
                    {liveUrl ? (
                        <a
                            href={liveUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="wg-live-link"
                        >
                            {liveUrl}
                        </a>
                    ) : (
                        <span>-</span>
                    )}
                </div>
            </div>
        </div>
    );
}

function ReviewGroup({ title, items }) {
    return (
        <div className="wg-review-group">
            <h3 className="wg-review-group-title">{title}</h3>
            <div className="wg-review-grid">
                {items.map(([label, value]) => (
                    <div className="wg-review-item" key={label}>
                        <strong>{label}</strong>
                        <span>{value || "-"}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

function formatTheme(themeKey) {
    if (!themeKey) return "-";

    return themeKey
        .split("-")
        .filter(Boolean)
        .map((x) => x.charAt(0).toUpperCase() + x.slice(1))
        .join(" ");
}